import './AddAgentRow.scss'
import React from 'react'
import { connect } from 'react-redux'
import { show as showModal } from 'redux-modal'

import OpTextbox from 'common/views/components/OpTextbox'
import OpSelect from 'common/views/components/OpSelect'
import OpCheckbox from 'common/views/components/OpCheckbox'
import RecommendBadge from 'common/views/components/RecommendBadge'
import FeedbackCheckbox from "common/views/components/FeedbackCheckbox";

import { AGENT_EXPERIENCE_LEVELS_SHORT } from 'common/constants'
import { editAgentInvite, toggleIsAgentInviteSelected, validateAgentEmail } from 'broker/redux/manage_users'

const ProductEnablementRow = ({ dispatch, isCore, isMVIP, invite }) => {
  const { selected, key, is_mvip_enabled, is_core_enabled } = invite
  return isCore && isMVIP ? (
    <div className="product-enablement-row">
      <div className="ml-10"><FeedbackCheckbox
        label={"Market VIP enabled"}
        checked={is_mvip_enabled}
        disabled={!selected}
        onChange={e => dispatch(editAgentInvite({ key, is_mvip_enabled: e.target.checked }))}
      />
      </div>
      <div className="ml-10"><FeedbackCheckbox
        label={"Core enabled"}
        checked={is_core_enabled}
        disabled={!selected}
        onChange={e => dispatch(editAgentInvite({ key, is_core_enabled: e.target.checked }))}
      />
      </div>
    </div>
  ) : <div></div>
}

const AddAgentRow = ({ invite, dispatch, idx, isCore, isMVIP, isRCCOnly, showExperienceLevelTip }) => {
  const { email, name, selected, experience_level, key, emailErrorMessage, experienceLevelErrorMessage, recommended } = invite

  const showTooltip = idx === 0
  return (
    <div>
      <div className={recommended ? "AddAgentRow recommended" : "AddAgentRow"}>

        <div className="main-list-wrapper">
          <div className="agent-email-wrapper">
            <OpCheckbox
              checked={selected}
              buttonClass="agent-row-checkbox"
              onChange={() => {
                dispatch(toggleIsAgentInviteSelected({...invite}))
              }}
            />

            <div className="agent-email">
              <OpTextbox
                label="Agent Email"
                iconClass="fa fa-envelope"
                value={email}
                disabled={!selected}
                errorMsg={emailErrorMessage}
                onBlur={() => dispatch(validateAgentEmail({ key }))}
                onChange={e => dispatch(editAgentInvite({ key, email: e.target.value }))}
                required
              />
            </div>
          </div>

          <div className="agent-name">
            <OpTextbox
              label="Agent Name"
              iconClass="fa fa-user-circle"
              value={name}
              disabled={!selected}
              onChange={e => dispatch(editAgentInvite({ key, name: e.target.value }))}
            />
          </div>

          {!isRCCOnly && <div className="agent-type">
            <OpSelect
              label="Agent Type"
              placeholder="Select..."
              tooltipButtonText={showTooltip ? 'What\'s this?' : null}
              onTooltipButtonClick={showTooltip ? showExperienceLevelTip : () => {}}
              clearable={false}
              searchable={false}
              backspaceRemoves={false}
              value={experience_level}
              disabled={!selected}
              errorMsg={experienceLevelErrorMessage}
              onChange={option => dispatch(editAgentInvite({ key, experience_level: option.value }))}
              options={AGENT_EXPERIENCE_LEVELS_SHORT}
              required
            />
          </div>}
        </div>
        {!!recommended && <div className="recommend-badge"><RecommendBadge /></div>}
      </div>
      <ProductEnablementRow dispatch={dispatch} isCore={isCore} isMVIP={isMVIP} invite={invite} />
  </div>
  )
}

const mapStateToProps = () => ({})
const mapDispatchToProps = dispatch => ({
  dispatch,
  showExperienceLevelTip: () => dispatch(showModal('ExperienceLevelTipModal'))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddAgentRow)
